import React from "react";
import {
    buttonStyle,
    cancelStyle,
    fieldActionStyle,
    inputStyle1,
    labelStyle,
    liStyle,
    plainListStyle
} from "./eventStyles";

/**
 * Draft input + “Add point” control and a removable list for repeating text sections (included, terms, etc.).
 * Parameterized by labels/field wiring so `EventForm` can render three sections with one component.
 */
const EventPointListField = ({
    label,
    draftValue,
    placeholder,
    points,
    onDraftChange,
    onAdd,
    onRemove
}) => (
    <>
        <label style={labelStyle}>{label}</label>
        <div style={fieldActionStyle}>
            <input
                type="text"
                value={draftValue}
                onChange={(event) => onDraftChange(event.target.value)}
                style={inputStyle1}
                placeholder={placeholder}
            />
            <button type="button" onClick={onAdd} style={buttonStyle}>
                Add Point
            </button>
        </div>

        <ul style={plainListStyle}>
            {points.map((point, index) => (
                <li key={`${label}-${index}`} style={liStyle}>
                    <span>{point}</span>
                    <button type="button" onClick={() => onRemove(index)} style={cancelStyle}>
                        Remove
                    </button>
                </li>
            ))}
        </ul>
    </>
);

export default EventPointListField;
